import { createFileRoute } from "@tanstack/react-router";

import { faq } from "@/landing/components/data";
import LandingPage from "@/landing/page";
import { toSafeJsonLdString } from "@/utils/safeJsonLd";

const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "DiningMate",
    url: "https://diningmate.com.au",
    logo: "https://diningmate.com.au/og-image.png",
    contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        areaServed: "AU",
        availableLanguage: "English",
    },
};

const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "DiningMate",
    url: "https://diningmate.com.au",
    potentialAction: {
        "@type": "SearchAction",
        target: {
            "@type": "EntryPoint",
            urlTemplate: "https://diningmate.com.au/?q={search_term_string}",
        },
        "query-input": "required name=search_term_string",
    },
};

const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((item) => ({
        "@type": "Question",
        name: item.title,
        acceptedAnswer: {
            "@type": "Answer",
            text: item.text,
        },
    })),
};

export const Route = createFileRoute("/")({
    head: () => ({
        meta: [
            { title: "DiningMate — Smart Restaurant Reservations" },
            {
                name: "description",
                content:
                    "Smart restaurant reservations for Australian hospitality. Manage bookings, reduce no-shows, and delight your guests — all in one place.",
            },
            { property: "og:url", content: "https://diningmate.com.au/" },
        ],
        links: [{ rel: "canonical", href: "https://diningmate.com.au/" }],
        scripts: [
            {
                type: "application/ld+json",
                children: toSafeJsonLdString(organizationSchema),
            },
            {
                type: "application/ld+json",
                children: toSafeJsonLdString(webSiteSchema),
            },
            {
                type: "application/ld+json",
                children: toSafeJsonLdString(faqSchema),
            },
        ],
    }),
    component: LandingPage,
});
